import { render, staticRenderFns } from "./modify-resource.vue?vue&type=template&id=b24d7968&scoped=true"
import script from "./modify-resource.vue?vue&type=script&lang=ts"
export * from "./modify-resource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24d7968",
  null
  
)

export default component.exports